import React from 'react';

import { WarningAmber } from '@mui/icons-material';

import { LendingValueBadgeEnum } from '../types';
import { ValueBadge } from '../../Badge/ValueBadge';

import messages from '../messages.json';

export type LendingValueBadgeProps = {
  valueBadge: LendingValueBadgeEnum;
};

export function LendingValueBadge({ valueBadge }: LendingValueBadgeProps) {
  const UpstartIcon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      viewBox="0 0 33 22"
      fill="none"
    >
      <path
        d="M4.21944 9.67516L1.67209 12.2183C-0.557363 14.4478 -0.557363 18.0994 1.67209 20.3247V20.3288C3.90154 22.5541 7.55316 22.5541 9.77843 20.3288L15.4504 14.6569V14.6695C15.6762 14.4896 15.9607 14.3808 16.2702 14.3808C16.5797 14.3808 16.8642 14.4896 17.09 14.6695H17.1026L12.2128 9.78391C10.0085 7.58374 6.46144 7.54609 4.21944 9.67516Z"
        fill="#00807B"
      />
      <path
        d="M30.8641 12.2183L20.3317 1.68175L20.3233 1.67339C20.1853 1.53535 20.0389 1.40569 19.8883 1.28438C17.6463 -0.551882 14.3042 -0.418031 12.2128 1.6692C12.1752 1.70685 12.1417 1.7445 12.1041 1.78214L11.7904 2.09585L4.21524 9.67515C6.46142 7.54609 10.0085 7.58374 12.2086 9.78809L17.0942 14.6736L22.7536 20.3288C24.983 22.5583 28.6346 22.5583 30.8641 20.3288C33.0977 18.0952 33.0977 14.4478 30.8641 12.2183Z"
        fill="#00B1AC"
      />
    </svg>
  );

  switch (valueBadge) {
    case LendingValueBadgeEnum.ORIGINAL_REQUESTED_TERMS:
      return (
        <ValueBadge
          label={messages.lendingValueBadge.originalRequestLabel}
          badgeStyle="primary"
          tooltip={messages.lendingValueBadge.originalRequestTooltip}
        />
      );
    case LendingValueBadgeEnum.LONGER_TERM_LOWER_APR:
      return (
        <ValueBadge
          label={messages.lendingValueBadge.longerTermLowerAprLabel}
          badgeStyle="primary"
          tooltip={messages.lendingValueBadge.longerTermLowerAprTooltip}
        />
      );
    case LendingValueBadgeEnum.SHORTER_TERM_LOWER_APR:
      return (
        <ValueBadge
          label={messages.lendingValueBadge.shorterTermLowerAprLabel}
          badgeStyle="primary"
          tooltip={messages.lendingValueBadge.shorterTermLowerAprTooltip}
        />
      );
    case LendingValueBadgeEnum.HIGHER_DOWN_PAYMENT_LOWER_APR:
      return (
        <ValueBadge
          label={messages.lendingValueBadge.higherDownPaymentLowerAprLabel}
          badgeStyle="primary"
          tooltip={messages.lendingValueBadge.higherDownPaymentLowerAprTooltip}
        />
      );
    case LendingValueBadgeEnum.BEST_APR:
      return (
        <ValueBadge
          icon={UpstartIcon}
          label={messages.lendingValueBadge.bestAprLabel}
          badgeStyle="secondary"
        />
      );
    case LendingValueBadgeEnum.NEXT_BEST_APR:
      return (
        <ValueBadge
          icon={UpstartIcon}
          label={messages.lendingValueBadge.nextBestAprLabel}
          badgeStyle="secondary"
          tooltip={messages.lendingValueBadge.nextBestAprTooltip}
        />
      );
    case LendingValueBadgeEnum.NEEDS_ADJUSTMENT:
      return (
        <ValueBadge
          icon={<WarningAmber />}
          label={messages.lendingValueBadge.needsAdjustmentLabel}
          badgeStyle="error"
        />
      );
    case LendingValueBadgeEnum.APPLICANT_DENIED:
      return (
        <ValueBadge
          label={messages.lendingValueBadge.applicantDeniedLabel}
          badgeStyle="default"
        />
      );
    default:
      return null;
  }
}
